import { Property, PropertyType } from '../../../../base/types';

import { IProperty } from '../../../../base/models';

export const IncidentProperties: IProperty[] = [
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Title, name: 'Title', type: PropertyType.String },
    { id: Property.Entity, name: 'Entity', type: PropertyType.Entity },
    { id: Property.EntityId, name: 'EntityId', type: PropertyType.String },
    { id: Property.Collapsible, name: 'Collapsible', type: PropertyType.Boolean },
    { id: Property.HeaderClass, name: 'Header Class', type: PropertyType.String },
    { id: Property.TableLookup, name: 'Table Lookup', type: PropertyType.TableLookup },
]
